import { useState } from "react";
import { AlertTriangle, ClipboardCheck, Send } from "lucide-react";
import CalendarOpsQueuePanel from "./CalendarOpsQueuePanel";
import BookingRequestsPanel from "./BookingRequestsPanel";
import AppointmentWorklistPanel from "./AppointmentWorklistPanel";

const TASK_TABS = [
  { key: "attention", label: "Attention", Icon: AlertTriangle },
  { key: "requests", label: "Requests", Icon: Send },
  { key: "confirmations", label: "Confirmations", Icon: ClipboardCheck },
];

// Calendar is a schedule first surface. The fuller operational tools still
// belong here, but only when a front-desk user deliberately opens Tasks.
export default function CalendarTasksPanel({
  branchId,
  doctors,
  chairs,
  settings,
  readOnly,
  onOpenAppointment,
  onChanged,
}) {
  const [activeTab, setActiveTab] = useState("attention");

  return (
    <div className="p-4" data-testid="calendar-tasks-panel">
      <p className="text-sm font-semibold text-slate-950">Today&apos;s tasks</p>
      <p className="mt-1 text-xs leading-5 text-slate-500">
        Review these only when you need to take action. Your schedule stays clear in the Calendar.
      </p>

      <div className="mt-4 flex gap-1 overflow-x-auto border-b border-slate-200" role="tablist" aria-label="Calendar tasks">
        {TASK_TABS.map(({ key, label, Icon }) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={activeTab === key}
            onClick={() => setActiveTab(key)}
            data-testid={`calendar-task-tab-${key}`}
            className={[
              "inline-flex shrink-0 items-center gap-1.5 border-b-2 px-3 py-2.5 text-xs font-bold transition",
              activeTab === key
                ? "border-teal-600 text-teal-700"
                : "border-transparent text-slate-500 hover:text-slate-900",
            ].join(" ")}
          >
            <Icon className="h-3.5 w-3.5" />
            {label}
          </button>
        ))}
      </div>

      <div className="mt-4">
        {activeTab === "attention" ? (
          <CalendarOpsQueuePanel branchId={branchId} onOpenAppointment={onOpenAppointment} />
        ) : null}
        {activeTab === "requests" ? (
          <BookingRequestsPanel
            branchId={branchId}
            doctors={doctors}
            chairs={chairs}
            settings={settings}
            readOnly={readOnly}
            onChanged={onChanged}
          />
        ) : null}
        {activeTab === "confirmations" ? (
          <AppointmentWorklistPanel
            doctors={doctors}
            chairs={chairs}
            branchId={branchId}
            onChanged={onChanged}
          />
        ) : null}
      </div>
    </div>
  );
}
